import { CustomTabPanel } from "@/erp/sale";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import TableEstadoVentaCorporativo from "../shared/TableEstadoVentaCorporativo";
import { a11yProps, EstadoProspectoEnum, sizeTab } from "@/shared";
import { useState } from "react";


export default function EstadoVentaCorporativoPage() {
    const [valueTab, setValueTab] = useState(0);

    return (
    <SingleTableBoxScene
      title={"Estado Venta Corporativo"}
      visibleReport={true}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={'Ventas Realizadas'} {...a11yProps(0)} />
          <Tab label={'Rechazadas'} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TableEstadoVentaCorporativo 
          estado_prospecto_exclude={EstadoProspectoEnum.CANCELADO}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TableEstadoVentaCorporativo
          estado_prospecto={EstadoProspectoEnum.CANCELADO}
        />
      </CustomTabPanel>

    </SingleTableBoxScene>
  )
}
